import {
  ISearch,
  ISearchProfile,
  ISearchProvider,
  HorizAlignment,
  SearchProviderFieldType,
  ISearchProviderField, ISearchRequestSubset
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {PASearch, ISearchRequest} from "../PA.Core/PASearch";
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PlanningLevelSearch} from "./PlanningLevelSearch";
import * as _ from "lodash";
import {TPMPlanSearch} from "./TPMPlanSearch";
import {ColumnNodeProvider} from "../PA.UIM.Core/SearchTreeUtils";
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import {IUsrContext} from "../PA.Core/PA.Core.IF.User";

var TPMBulkApprovalSearch: ISearch = {
  searchName: "Find TPM Plan",
  renderOptions: { ui5ResourceId: "TPMBulkApprovalSearch"},
  searchProfileIdDefault: "default",
  searchProfiles: []
}

var vUI_TPM_Bulk_Approval_Search_Fields: {[id:string]: ISearchProviderField } = {

  WB_PLAN_ID:           {type: SearchProviderFieldType.number, renderOptions: { columnName: 'WB Plan Id', columnResourceName: 'colId', alignment: HorizAlignment.Center}, domainOptions: {}},
  PLAN_ID:            {type: SearchProviderFieldType.string, renderOptions: {columnWidthCharacters: 8, columnName: 'Plan Id', columnResourceName: 'colId', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
  PLAN_NAME:          {type: SearchProviderFieldType.string, renderOptions: {columnWidthCharacters: 25, columnName: 'Plan Name', columnResourceName: 'colName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},

  WB_PLANM_ID:           {type: SearchProviderFieldType.number, renderOptions: { columnName: 'WB Plan Type Id', columnResourceName: 'colTypeId', alignment: HorizAlignment.Center}, domainOptions: {}},
  PLAN_TYPE:           {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Plan Type', columnResourceName: 'colTypeName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
  WB_PLNMGMT_ID:               {type: SearchProviderFieldType.number,  renderOptions: { columnName: 'Plan Mgmt ID',            columnResourceName: 'colPlanMgmtID',   alignment: HorizAlignment.Left}, domainOptions: { }},

  PLANNING_CUSTOMER_NAME:    {type: SearchProviderFieldType.string, renderOptions: {columnWidthCharacters: 20, columnName: 'Planning Customer', columnResourceName: 'colPlanningCustomer', alignment: HorizAlignment.Left}, domainOptions: { search: TPMBulkApprovalSearch, profileId:"default", bUseSearchProvidersDistinctValues: true,maxLength: 256}},
  WB_CUST_ID_PLANNING:        {type: SearchProviderFieldType.number,  renderOptions: { columnName: 'WB Plan Customer ID',            columnResourceName: 'colWBPlanCustID',   alignment: HorizAlignment.Left}, domainOptions: { }},
  WB_SALESORG_ID:             {type: SearchProviderFieldType.number,  renderOptions: { columnName: 'WB Sales Org Id',            columnResourceName: 'colwbSalesOrgId',   alignment: HorizAlignment.Left}, domainOptions: { }},

  PLANNING_LEVEL_NAME:  {type: SearchProviderFieldType.string,  renderOptions: {columnWidthCharacters: 20, columnName: 'Planning Level',          columnResourceName: 'colLevelName', alignment: HorizAlignment.Left}, domainOptions: { search: TPMBulkApprovalSearch, profileId: "default", bUseSearchProvidersDistinctValues: true, maxLength: 256}},

  PLAN_PERIOD:            {type: SearchProviderFieldType.string,  renderOptions: {columnWidthCharacters: 8, columnName: 'Plan Period',             columnResourceName: 'colPlanPeriodName', alignment: HorizAlignment.Left}, domainOptions: {search: TPMBulkApprovalSearch, profileId: "default", bUseSearchProvidersDistinctValues: true,  maxLength: 256}},
  WB_PERIOD_ID:           {type: SearchProviderFieldType.number, renderOptions: { columnName: 'WB Period Id', columnResourceName: 'colWBPeriodId', alignment: HorizAlignment.Left}, domainOptions: { search: TPMBulkApprovalSearch, profileId: "default", bUseSearchProvidersDistinctValues: true, maxLength: 256}},

  EVENT_COUNT:          {type: SearchProviderFieldType.number,  renderOptions: {columnWidthCharacters: 8, columnName: '# Unapproved Events',           columnResourceName: 'colEventCount', alignment: HorizAlignment.Right, numberFormat: "#,##0"}, domainOptions: {}}
}

function addUserGroupPlanFilter(findRequest: ISearchRequest): Promise<void> {
  let usrContext: IUsrContext = PAEnvironment.getValue(PAEnvironment.UserContext)
  SearchUtils.addUsrContextSalesOrgFilter(findRequest, 'WB_SALESORG_ID')
  if (usrContext.hasRoleId('VIEW_ALL')) {
    return Promise.resolve()
  }
  SearchUtils.addUsrContextCustomerFilter(findRequest, 'WB_CUST_ID_PLANNING')
  return SearchUtils.addUserGroupPlansFilter(findRequest, 'WB_PLAN_ID')
}

var TPMBulkApprovalSearchProviderBasic: ISearchProvider = {

  keyFields: {id:        'WB_PLAN_ID',
              id_ui:     'PLAN_ID',
              name:      'PLAN_NAME'
  },

  searchProviderFields: vUI_TPM_Bulk_Approval_Search_Fields,

  search(searchRequestSubset: ISearchRequestSubset): Promise<any[]> {
    return new Promise<any[]>((resolve, error) => {

      let findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
        'vUI_TPM_Bulk_Approval_Search',
        this.searchProviderFields,
        [])

      addUserGroupPlanFilter(findRequest)
        .then((ignore => {
          return PASearch.findByRequest(findRequest)
        }))
        .then((res: any[]) => {
          resolve(res)
        })
        .catch((err)=> {
          error(err)
        })
    })
  },

  // Filter with drop down in the TPM Event Search
  distinctValues(fieldName: string): Promise<string[] | number[]> {
    return new Promise<string[] | number[]>((resolve, error) => {
      let findRequest = SearchUtils.makeSearchRequest({},
          'vUI_TPM_Bulk_Approval_Search',
          this.searchProviderFields,
          [fieldName])

      addUserGroupPlanFilter(findRequest)
          .then((ignore) => {
            return PASearch.findByRequest(findRequest)
          })
          .then((res: any[]) => {
            resolve(_.map(res, (aRow) => { return aRow[fieldName] }))
          })
          .catch((err)=> {
            error(err)
          })
    })
  }

}

var TPMBulkApprovalSearchProviderApproved: ISearchProvider = {

  keyFields: {id:        'WB_PLAN_ID',
    id_ui:     'PLAN_ID',
    name:      'PLAN_NAME'
  },

  searchProviderFields: vUI_TPM_Bulk_Approval_Search_Fields,

  search(searchRequestSubset: ISearchRequestSubset): Promise<any[]> {
    return new Promise<any[]>((resolve, error) => {
debugger
      let findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
          'vUI_TPM_Bulk_Approval_Search_Approved_Events',
          this.searchProviderFields,
          [])

      addUserGroupPlanFilter(findRequest)
          .then((ignore => {
            return PASearch.findByRequest(findRequest)
          }))
          .then((res: any[]) => {
            resolve(res)
          })
          .catch((err)=> {
            error(err)
          })
    })
  },

  // Filter with drop down in the TPM Event Search
  distinctValues(fieldName: string): Promise<string[] | number[]> {
    return new Promise<string[] | number[]>((resolve, error) => {
      let findRequest = SearchUtils.makeSearchRequest({},
          'vUI_TPM_Bulk_Approval_Search_Approved_Events',
          this.searchProviderFields,
          [fieldName])

      addUserGroupPlanFilter(findRequest)
          .then((ignore) => {
            return PASearch.findByRequest(findRequest)
          })
          .then((res: any[]) => {
            resolve(_.map(res, (aRow) => { return aRow[fieldName] }))
          })
          .catch((err)=> {
            error(err)
          })
    })
  }

}

var TPMBulkApprovalSearchProfileUnapproved: ISearchProfile = {
  profileId: "default",
  profileName: "Search Unapproved Plans",
  renderOptions: { ui5ResourceId: "TPMBulkApprovalSearchProfileUnapproved" },

  profileFilter: [
    {profileFilterName: 'Customer',                 searchProviderFieldId: 'PLANNING_CUSTOMER_NAME', bMultiSelect: true, renderOptions: {}},
    {profileFilterName: 'Plan Id',               searchProviderFieldId: 'PLAN_ID',          renderOptions: { }},
    {profileFilterName: 'Plan Name',               searchProviderFieldId: 'PLAN_NAME',      renderOptions: {}},
    {profileFilterName: 'Fiscal Year',     searchProviderFieldId: 'PLAN_PERIOD', bMultiSelect: true, renderOptions: {}}

  ],  // ISearchFields
  profileDisplayFields: [
    'PLAN_NAME', 'PLAN_ID', 'EVENT_COUNT','PLANNING_CUSTOMER_NAME'
    ,'PLANNING_LEVEL_NAME','PLAN_PERIOD','PLAN_TYPE', {columnTitle: "Lock", lockClass: "TPMPlan", lockIdFieldName: "WB_PLAN_ID", bDisplayLockIcon: true, bDisplayLockOwner:true}
  ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

  profileSearchProvider: TPMBulkApprovalSearchProviderBasic,

  // Do sorting last.. not necessary for phase 1
  profileSortIdDefault: "",    //string;
  profileSorts: [] //ISearchSort[];
}


var TPMBulkApprovalSearchProfileApproved: ISearchProfile = {
  profileId: "approvedPlans",
  profileName: "Search Approved Plans",
  renderOptions: { ui5ResourceId: "TPMBulkApprovalSearchProfileApproved" },

  profileFilter: [
    {profileFilterName: 'Customer',                 searchProviderFieldId: 'PLANNING_CUSTOMER_NAME', bMultiSelect: true, renderOptions: {}},
    {profileFilterName: 'Plan Id',               searchProviderFieldId: 'PLAN_ID',          renderOptions: { }},
    {profileFilterName: 'Plan Name',               searchProviderFieldId: 'PLAN_NAME',      renderOptions: {}},
    {profileFilterName: 'Fiscal Year',     searchProviderFieldId: 'PLAN_PERIOD', bMultiSelect: true, renderOptions: {}}

  ],  // ISearchFields
  profileDisplayFields: [
    'PLAN_NAME', 'PLAN_ID', 'EVENT_COUNT','PLANNING_CUSTOMER_NAME'
    ,'PLANNING_LEVEL_NAME','PLAN_PERIOD','PLAN_TYPE'
  ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

  profileSearchProvider: TPMBulkApprovalSearchProviderApproved,

  // Do sorting last.. not necessary for phase 1
  profileSortIdDefault: "",    //string;
  profileSorts: [] //ISearchSort[];
}



TPMBulkApprovalSearch.searchProfiles = [TPMBulkApprovalSearchProfileUnapproved, TPMBulkApprovalSearchProfileApproved]

export {TPMBulkApprovalSearch}